import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Topbar from "../Topbar/Topbar";
import { FaStarOfLife } from "react-icons/fa6";
import { Modal, Box, Button } from "@mui/material";
import { ImCross } from "react-icons/im";
import { FiX, FiUpload } from "react-icons/fi"; // Close & Upload icons
import { MdPadding } from "react-icons/md";
import "./Add_Complaint.css"
import axios from "axios";
import MessageBox from "../MessageBox/MessageBox";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useEffect } from "react";
import dayjs from 'dayjs';
import { FaUserEdit } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import { useRef } from "react";

import _ from 'lodash';


import { useSelector } from "react-redux";

export default function Add_Complaint() {
  const navigate=useNavigate();
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [complaintId, setComplaintId] = useState(null); // Add this to your component
const[pageRefId,setpageRefId]=useState("")
  const Id = useSelector((state) => state.id);
  const [messageData, setMessageData] = useState(null);
  const [showMessageBox, setShowMessageBox] = useState(false);
 const [names, setNames] = useState([]);
  const [approvePersons, setApprovePersons] = useState([]);  // Array of selected persons
  const [isApproveOpen, setIsApproveOpen] = useState(false);
  const approveDropdownRef = useRef(null);
    const [searchText, setSearchText] = useState('');
    const [isOpen, setIsOpen] = useState(false);
      const [selectedNames, setSelectedNames] = useState([]);
    
  const currentTime = dayjs().format('hh:mm A'); // Example: "11:42:00 AM"
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isEditable, setIsEditable] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false); // to track update mode
  const [originalComplaint, setOriginalComplaint] = useState(null);
const staffName = useSelector((state) => state.staffname);
const [searchTerm, setSearchTerm] = useState("");

// ── Completed Customers (for Customer Affected dropdown) ──
const [completedCustomers, setCompletedCustomers] = useState([]);
const [customerSearch, setCustomerSearch] = useState("");
const [isCustomerDropOpen, setIsCustomerDropOpen] = useState(false);
const [selectedCustomer, setSelectedCustomer] = useState(null);
const customerDropRef = useRef(null);

const formatDate = (date) => {
    return dayjs(date).format('DD-MM-YYYY');
  };



  const [addComplaint, setAddComplaint] = useState({
     leadId: "",
      createdDate: "",
      complaintcustomerAffected: "",
      complaintType:"",
      complaintcustomerName: "",
      complaintcontactNum: "", 
      complaintaddress: "",
      location:"",
      complaintnetwork:false,
      complaintfiber:false,
      complaintadditionalCharges:"",

     leadStatus:"Open",
  
    
      complaintleadStatus: {
        complaintnotes: "",
        complaintLeadStatusnextFollowUpDate: "",
  
        
      },
      verification: {
      verificationStatus: "",
      nextFollowUpDate: "",
      notes: "",
      verificationImage: "",
      updatedBy: "",
      updatedTime: "",
      updatedDate: "",
     


    },
    workAssign: {
      fiberTeam: [{
        materialRequire: "",
        materilType: "",
        unit: "",
        updatedBy: "",
        updatedTime: "",
        updatedDate: ""
      }],

      networkTeam:[ {
        materialRequire: "",
        materilType: "",
        unit: "",
        updatedBy: "",
        updatedTime: "",
        updatedDate: ""

      }]

    },

    feedback: {
      notes: "",
      updatedBy: "",
      updatedTime: "",
      updatedDate: ""

    },
    }
    );
 
   const [taskData, setTaskData] = useState({
     taskName: "Complaint",
     assignedBy: staffName,
     assignDateTime: "",
    //  taskType: "Once",
     taskPriority: "Low",
     deadline: "",
     time: "",
     assignedTo: [{}], // Array for multiple selections
     approvePerson: "",
     description: "",
     name: addComplaint?.enquirycustomerName || "",
     leadId: addComplaint?.leadId || "",
     taskStatus: "Open",
 
   });
  const dropdownRef = useRef(null);
   const dropdownRefOtt = useRef(null);
    // Close dropdown when clicking outside
  
   
     const filteredNames = names.filter(staff =>
       staff.staffName.toLowerCase().includes(searchTerm.toLowerCase())
     );
  
  const convertStringToObject = (locationString) => {
    // Split the input string by a comma and trim whitespace
    const [latitude, longitude] = locationString
      .split(",")
      .map((value) => value.trim());

    // Return the object with parsed latitude and longitude
    return {
      latitude: parseFloat(latitude),
      longitude: parseFloat(longitude),
    };
  };


  // Example usage
  // const locationString = "12.23456, 13.123456";
  // const locationObject = convertStringToObject(locationString);

  // console.log(locationObject, "object");
  //-----str to objet---
  const convertLocationObjectToString = (locationObject) => {
    const { latitude, longitude } = locationObject;

    // Return the formatted string
    return `${latitude}, ${longitude}`;
  };

  // Example usage
  // const locationObjectS = {
  //   latitude: 12.23456,
  //   longitude: 13.123456,
  // };

  // const locationStringS = convertLocationObjectToString(locationObjectS);

  // console.log(locationStringS, "string");

  // const formatDate = (date) => {
  //   return dayjs(date).format("DD-MM-YYYY");
  // };
// 
  // const [taskData, setTaskData] = useState({
  //   taskName: "Complaint",
  //   assignedBy: staffName,
  //   assignDateTime: "",
  //   //  taskType: "Once",
  //   taskPriority: "Low",
  //   deadline: "",
  //   time: "",
  //   assignedTo: [{}], // Array for multiple selections
  //   approvePerson: "",
  //   description: "",
  //   name: addComplaint?.enquirycustomerName || "",
  //   leadId: addComplaint?.leadId || "",
  //   taskStatus: "Open",
  // });
  // const dropdownRef = useRef(null);
  // const dropdownRefOtt = useRef(null);
  // // Close dropdown when clicking outside

  // const filteredNames = names.filter((staff) =>
  //   staff.staffName.toLowerCase().includes(searchTerm.toLowerCase())
  // );

  const [isOpenAssign, setIsOpenAssign] = useState(false);



  const [selectedFile, setSelectedFile] = useState(null);


  const[isOpenAdvancePayment,setIsOpenAdvancePayment]=useState(false)

  // Handle file selection
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleLeadChange = (e) => {
    const { name, value } = e.target;
    setAddComplaint(prevState => ({
        ...prevState,
        complaintleadStatus: {
            ...prevState.complaintleadStatus,
            [name]: value
        }
    }));
};

  const [isOpenplan, setIsOpenplan] = useState(false);
  const [isOpenComplaintOpen, setIsOpenComplaintOpen] = useState(false);

  const handleChange = (e) => {
    setAddComplaint({ ...addComplaint, [e.target.name]: e.target.value });
  };

  const handleChangecheckbox = (e) => {
    setAddComplaint((prev) => ({
      ...prev,
      [e.target.name]: e.target.checked,
    }));

    console.log(e.target.name, e.target.checked);
  };


   const handleInputChange = (field, value) => {
    if (field === 'time') {
      const [hours, minutes] = value.split(':');
      let hh = parseInt(hours, 10);
      const ampm = hh >= 12 ? 'PM' : 'AM';
      hh = hh % 12 || 12;
      const formattedTime = `${hh.toString().padStart(2, '0')}:${minutes} ${ampm}`;

      setTaskData(prev => ({
        ...prev,
        time: formattedTime, // Store as "hh:mm AM/PM"
        timeRaw: value        // Optional: keep raw value like "17:17" if needed
      }));
    } else {
      setTaskData(prev => ({
        ...prev,
        [field]: value
      }));
    }
  };


  const toggleApproveDropdown = () => {
    setIsApproveOpen(prev => !prev);
  };


  const handleApproveCheckboxChange = (staff) => {
    setApprovePersons(prev => {
      const exists = prev.find(item => item._id === staff._id);
      if (exists) {
        // Remove staff
        return prev.filter(item => item._id !== staff._id);
      } else {
        // Add staff
        return [...prev, staff];
      }
    });
  };
  const approvePersonText = approvePersons.length > 0
    ? approvePersons.map(item => item.staffName).join(', ')
    : 'Select Approve Persons';

    const toggleDropdown = () => {
    setIsOpen(prev => !prev);
  };

 const displayText = selectedNames.length > 0
    ? selectedNames.map(item => item.staffName).join(', ')
    : 'Select names';

  const handleCheckboxChange = (staff) => {
    setSelectedNames(prev => {
      const exists = prev.find(item => item._id === staff._id);
      if (exists) {
        // remove staff
        return prev.filter(item => item._id !== staff._id);
      } else {
        // add staff
        return [...prev, staff];
      }
    });
  };
  
  useEffect(() => {
        fetch(apiUrl +"generate-lead-id-complaint")
          .then((res) => res.json())
          .then((data) => {
            console.log("Fetched Lead ID:", data.leadId); // Debugging log
      
            setAddComplaint((prev) => ({
              ...prev, // Spread previous state
              leadId: data.leadId, // Update only the leadId field
              createdDate: new Date().toISOString().split("T")[0], // Set today's date
            }));
          })
          .catch((error) => console.error("Error fetching Lead ID:", error));
      }, []);


      const isEqual = (obj1, obj2) => {
        return JSON.stringify(obj1) === JSON.stringify(obj2);
      };
      
    //  const handleSubmit = async (e) => {
    //    e.preventDefault();
     
    //    if (isEditMode && _.isEqual(addComplaint, originalComplaint)) {
    //      Swal.fire("No Changes", "No changes were made to update.", "info");
    //      return;
    //    }
     
    //    const result = await Swal.fire({
    //      title: isEditMode ? "Update the changes?" : "Are you sure?",
    //      showCancelButton: true,
    //      confirmButtonText: isEditMode ? "Update" : "Submit",
    //    });
     
    //    if (!result.isConfirmed) return;
     
    //    const now = new Date();
    //    const date = now.toLocaleDateString();
    //    const time = now.toLocaleTimeString();
     
    //    const updatedComplaintDetails = {
    //      ...addComplaint,
    //      leadId: addComplaint.leadId,
    //      createdBy: {
    //        staffName: staffName,
    //        _id: Id,
    //        time: time,
    //        date: date,
    //      },
    //    };
     
    //    if (isEditMode) {
    //      try {
    //        await axios.post(apiUrl + "update-lead-complaint", updatedComplaintDetails, {
    //          headers: { "Content-Type": "application/json" },
    //        });
     
    //        Swal.fire("Updated!", "Data updated successfully", "success");
    //        setIsEditable(false);
    //        setIsEditMode(false);
    //      } catch (error) {
    //        console.error("Update error:", error);
    //        Swal.fire("Error", error.response?.data?.message || "Something went wrong!", "error");
    //      }
    //    } else {
    //      axios
    //        .post(apiUrl + "add-lead-complaint", updatedComplaintDetails, {
    //          headers: { "Content-Type": "application/json" },
    //        })
    //        .then((response) => {
    //          const savedId = response.data.data?._id;
    //          setComplaintId(savedId);
    //          setpageRefId(savedId);
     
    //          const formData = new FormData();
    //          formData.append("pageRefId", savedId);
    //          formData.append("page", "Complaint");
    //          formData.append("colorCode", "#fbdc6e");
    //          formData.append("description", addComplaint.complaintleadStatus?.complaintnotes || "");
    //          formData.append("staffPic", "");
    //          formData.append("image", selectedFile);
    //          formData.append("updatesHistory[staff][name]", staffName);
    //          formData.append("updatesHistory[staff][id]", Id);
    //          formData.append("updatesHistory[status]", addComplaint.leadStatus);
     
    //          axios
    //    .post(apiUrl + "add-message", formData, {
    //      headers: { "Content-Type": "multipart/form-data" },
    //    })
    //    .then(() => {
    //      console.log("Project update sent.");
     
    //      // ✅ Fetch messages after update
    //      axios
    //        .get(`${apiUrl}messages/${savedId}`)
    //        .then((res) => {
    //          setMessageData(res.data.data);
    //          setShowMessageBox(true); // ✅ Only show message box here!
    //        })
    //        .catch((err) => {
    //          console.error("Fetching messages failed:", err);
    //        });
     
    //      Swal.fire("Success!", "Complaint Details Added", "success");
    //      setIsSubmitted(true);
    //      setIsEditable(false);
    //      setIsEditMode(false);
    //    })
     
    //            .then(() => {
    //              console.log("Project update sent.");
     
    //              // ✅ Fetch messages immediately after successful project update
    //              axios
    //                .get(`${apiUrl}messages/${savedId}`)
    //                .then((res) => {
    //                  setMessageData(res.data.data);
    //                  console.log("Fetched Messages:", res.data.data);
    //                })
    //                .catch((err) => {
    //                  console.error("Fetching messages failed:", err);
    //                });
     
    //              Swal.fire("Success!", "Complaint Details Added", "success");
    //              setIsSubmitted(true);
    //              setIsEditable(false);
    //              setIsEditMode(false);
    //            })
    //            .catch((err) => {
    //              console.error("Project update error:", err);
    //              Swal.fire("Warning", "Complaint saved, but project update failed.", "warning");
    //            });
    //        })
    //        .catch((error) => {
    //          console.error("Complaint add error:", error);
    //          Swal.fire("Error", error.response?.data?.message || "Something went wrong!", "error");
    //        });
    //    }
    //  };






const handleSubmit = async (e) => {
  e.preventDefault();

  // === Location validation ===
  // let locationObject;
  // try {
  //   locationObject = convertStringToObject(addComplaint.location);
  //   if (
  //     isNaN(locationObject.latitude) ||
  //     isNaN(locationObject.longitude)
  //   ) {
  //     throw new Error("Invalid location format");
  //   }
  // } catch (error) {
  //   Swal.fire(
  //     "Error",
  //     "Please enter a valid location in the format: 12.123456, 33.123456",
  //     "error"
  //   );
  //   return;
  // }

  // === No changes check ===
  if (isEditMode && _.isEqual(addComplaint, originalComplaint)) {
    Swal.fire("No Changes", "No changes were made to update.", "info");
    return;
  }

  const result = await Swal.fire({
    title: isEditMode ? "Update the changes?" : "Are you sure?",
    showCancelButton: true,
    confirmButtonText: isEditMode ? "Update" : "Submit",
  });

  if (!result.isConfirmed) return;

  // === Timestamps ===
  const now = new Date();
  const date = now.toLocaleDateString();
  const time = now.toLocaleTimeString();

  // === Final complaint object ===
  const updatedComplaintDetails = {
    ...addComplaint,
    location: addComplaint.location ? convertStringToObject(addComplaint.location) : {},
    leadId: addComplaint.leadId,
    createdBy: {
      staffName: staffName,
      _id: Id,
      time: time,
      date: date,
    },
  };

  if (isEditMode) {
    // === Update Mode ===
    try {
      await axios.post(apiUrl + "update-lead-complaint", updatedComplaintDetails, {
        headers: { "Content-Type": "application/json" },
      });

      Swal.fire("Updated!", "Data updated successfully", "success");
      setIsEditable(false);
      setIsEditMode(false);
    } catch (error) {
      console.error("Update error:", error);
      Swal.fire("Error", error.response?.data?.message || "Something went wrong!", "error");
    }
  } else {
    // === Create New Complaint ===
    axios
      .post(apiUrl + "add-lead-complaint", updatedComplaintDetails, {
        headers: { "Content-Type": "application/json" },
      })
      .then((response) => {
        const savedId = response.data.data?._id;
        setComplaintId(savedId);
        setpageRefId(savedId);

        // === Add Message ===
        const formData = new FormData();
        formData.append("pageRefId", savedId);
        formData.append("page", "Complaint");
        formData.append("colorCode", "#fbdc6e");
        formData.append("description", addComplaint.complaintleadStatus?.complaintnotes || "No Description");
        formData.append("staffPic", "");
        if (selectedFile) {
          formData.append("image", selectedFile);
        }
        formData.append("updatesHistory[staff][name]", staffName);
        formData.append("updatesHistory[staff][id]", Id);
        formData.append("updatesHistory[status]", addComplaint.leadStatus || "Open");

        axios
          .post(apiUrl + "add-message", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then(() => {
            axios
              .get(`${apiUrl}messages/${savedId}`)
              .then((res) => {
                setMessageData(res.data.data);
                setShowMessageBox(true);
              })
              .catch((err) => {
                console.error("Fetching messages failed:", err);
              });

            Swal.fire("Success!", "Complaint Details Added", "success");
            setIsSubmitted(true);
            setIsEditable(false);
            setIsEditMode(false);
          })
          .catch((err) => {
            console.error("Project update error:", err);
            Swal.fire("Warning", "Complaint saved, but project update failed.", "warning");
          });
      })
      .catch((error) => {
        console.error("Complaint add error:", error);
        Swal.fire("Error", error.response?.data?.message || "Something went wrong!", "error");
      });
  }
};

       const handleSubmitAssignTask = async (e) => {
         e.preventDefault();
     
         Swal.fire({
           title: "Are you sure you want to create this task?",
           showCancelButton: true,
           confirmButtonText: "Submit",
         }).then(async (result) => {
           if (result.isConfirmed) {
             try {
               const now = new Date();
               const day = String(now.getDate()).padStart(2, "0");
               const month = String(now.getMonth() + 1).padStart(2, "0");
               const year = now.getFullYear();
               const updatedDate = `${day}-${month}-${year}`;
     
               let hours = now.getHours();
               const minutes = String(now.getMinutes()).padStart(2, "0");
               const ampm = hours >= 12 ? "PM" : "AM";
               hours = hours % 12 || 12;
               const updatedTime = `${hours}:${minutes} ${ampm}`;
     
               const datas = {
                 ...taskData,
                 assignedBy: {
                   staffName: staffName,
                   id: Id
                 },
                 updatedDate,
                 updatedTime,
                 assignedTo: selectedNames,
                 approvePerson: approvePersons,
                 collectionId: complaintId
               };
     
               // Required fields to check
               const requiredFields = [
                 "taskName",
                 "assignDateTime",
                 // "taskPriority",
                 // "taskType",
                 "deadline",
                 "assignedTo",
                 "approvePerson",
                 "description",
               ];
     
               // Check for empty fields
               const emptyFields = requiredFields.filter(
                 (field) => !datas[field] || (Array.isArray(datas[field]) && datas[field].length === 0)
               );
     
               if (emptyFields.length > 0) {
                 Swal.fire({
                   icon: "warning",
                   title: "Incomplete Data",
                   text: `Please fill all the fields:`,
                 });
                 return;
               }
     
               const response = await axios.post(
                 apiUrl + "add-assign-task",
                 datas,
                 { headers: { "Content-Type": "application/json" } }
               );
     
               Swal.fire({
                 title: "Task Created Successfully!",
                 icon: "success",
               }).then(() => {
                 navigate("/task");
               });
             } catch (error) {
               console.log("Error submitting data:", error.response?.data || error.message);
               Swal.fire({
                 icon: "error",
                 title: "Oops...",
                 text: error.response?.data?.message || "Something went wrong!",
               });
             }
           }
         });
       };
     

      useEffect(() => {
         const now = new Date();
         const year = now.getFullYear();
         const month = String(now.getMonth() + 1).padStart(2, "0");
         const day = String(now.getDate()).padStart(2, "0");
         const hours = String(now.getHours()).padStart(2, "0");
         const minutes = String(now.getMinutes()).padStart(2, "0");
     
         const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}`;
     
         setTaskData(prev => ({
           ...prev,
           assignDateTime: formattedDate
         }));
       }, []);

        useEffect(() => {
           axios.get(apiUrl + "get-staff-names")
             .then((res) => {
               if (res.data.message) {
                 setNames(res.data.message);  // names = array of objects like { _id, staffName }
               }
             })
             .catch((err) => {
               console.log("Error fetching staff names:", err);
             });
       
           const handleClickOutside = (event) => {
             if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
               setIsOpen(false);
             }
           };
       
           document.addEventListener('mousedown', handleClickOutside);
           return () => {
             document.removeEventListener('mousedown', handleClickOutside);
           };
         }, []);

  // ── Fetch completed installation customers ──
  useEffect(() => {
    axios
      .get(apiUrl + "completed-customers")
      .then((res) => {
        if (res.data.success) {
          setCompletedCustomers(res.data.message || []);
        }
      })
      .catch((err) => {
        console.error("Error fetching completed customers:", err);
      });

    // Close customer dropdown on outside click
    const handleClickOutsideCustomer = (event) => {
      if (customerDropRef.current && !customerDropRef.current.contains(event.target)) {
        setIsCustomerDropOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutsideCustomer);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideCustomer);
    };
  }, []);

  return (
    <>
      <Topbar />
      <Container className="mt-1    ">
        <form onSubmit={handleSubmit}>
          <Row>
            <Col>
              <h3>Complaints</h3>
            </Col>

            {/* <Col className="mx-5 text-end">
              <button
                className=" blue-btn  px-4 text-white"
                value="submit"
                type="submit"
              >
                Submit
              </button>
            </Col> */}

<Col className="mx-5 text-end">
  {/* Initial Submit */}
 {/* Initial Submit (Add mode) */}
{!isSubmitted && !isEditMode && (
  <button
    className="blue-btn px-4 text-white"
    value="submit"
    type="submit"
  >
    Submit
  </button>
)}

{/* After Submit (Edit & Assign buttons) */}
{isSubmitted && !isEditable && (
  <>
    <button
      className=" black-btn  me-2"
      type="button"
      onClick={() => {
        setOriginalComplaint({ ...addComplaint }); // Backup current data
  setIsEditable(true);
  setIsEditMode(true);
      }}
    >
     <MdEdit size={18} /> Edit
    </button>
    {/* <button className=" blue-btn" type="button" onClick={() => setIsOpenAssign(true)}>
      <FaUserEdit size={18} /> Assign
    </button> */}

     {isOpenAssign && (
                        <div className="overlay3">
                          <div className="modal3">
                            <Container>
                              <div className=" text-end mx-2">
                                <button
                                  type="button"
                                  className="black-btn mx-3"
                                  onClick={() => setIsOpenAssign(false)}
                                >
                                  Cancel
                                </button>
                                <button
                                  type="button"
                                  className=" blue-btn mx-3"
                                  onClick={handleSubmitAssignTask}
                                >
                                  Submit
                                </button>
                              </div>
    
                              <Row className="mt-4">
                                <Col xs={12} md={6}>
                                  <Row>
                                    <Col xs={12} md={6} className="text-start">
                                      <lable>Task Name</lable>
                                      <br />
                                      <input
                                        type="text"
                                        className="form-input"
                                        readOnly
                                        value={taskData.taskName}
                                      />
                                    </Col>
                                    <Col xs={12} md={6} className="text-start">
                                      <lable>Assign Date/Time</lable>
                                      <br />
                                      <input
                                        type="datetime-local"
                                        value={taskData.assignDateTime}
                                        required
                                        className="form-input"
                                        onChange={(e) => handleInputChange('assignDateTime', e.target.value)}
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                                <Col>
                                  {/* <Row>
                                    <Col xs={12} md={6} className="text-start">
                                      <lable>Task Type</lable>
    
                                      <br />
                                      <select
                                        onChange={(e) =>
                                          handleInputChange(
                                            "taskType",
                                            e.target.value
                                          )
                                        }
                                        class="dropbtn form-input-select overlay2"
                                      >
                                        <option value="Once">Once</option>
                                        <option value="Daily">Daily</option>
                                        <option value="weekly">Weekly</option>
                                        <option value="Monthy">Monthly</option>
                                        <option value="Custom">Custom</option>
                                      </select>
                                    </Col>
    
                                    <Col xs={12} md={6} className="text-start">
                                      <lable>Task Priority </lable>
                                      <br />
                                      <select
                                        onChange={(e) =>
                                          handleInputChange(
                                            "taskPriority",
                                            e.target.value
                                          )
                                        }
                                        class="dropbtn form-input-select overlay2"
                                      >
                                        <option value="Low">Low</option>
                                        <option value="High">High</option>
                                        <option value="Immediate">Immediate</option>
                                      </select>
                                    </Col>
                                  </Row> */}
                                </Col>
                              </Row>
    
                              <Row>
                                <Col xs={12} md={6}>
                                  <Row>
                                    <Col xs={12} md={6} className="text-start">
                                      <lable>Deadline Date/Time</lable>
                                      <br />
                                      <input
                                        type="datetime-local"
                                        onChange={(e) =>
                                          handleInputChange(
                                            "deadline",
                                            e.target.value
                                          )
                                        }
                                        className="form-input overlay2"
                                        placeholder=""
                                        min={new Date().toISOString().split("T")[0]} // only allows today or future
    
                                      />
                                    </Col>
                                    {/* <Col xs={12} md={6} className="text-start">
                                      <lable>Deadline Time</lable>
                                      <br />
                                      <input
                                        type="time"
                                        onChange={(e) =>
                                          handleInputChange("time", e.target.value)
                                        }
                                        className="form-input overlay2"
                                        placeholder=""
                                      />
                                    </Col> */}
                                  </Row>
                                </Col>
                                <Col>
                                  <Row>
                                    <Col xs={12} md={6} className="text-start">
                                      <lable>Task Asign To</lable>
                                      <br />
                                      <div ref={dropdownRef} style={{ position: 'relative', width: '85%' }}>
                                        <div
                                          onClick={toggleDropdown}
                                          style={{
                                            padding: '10px',
                                            border: '2px solid #a7a7a7',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            backgroundColor: '#fff',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginTop: "10px"
                                          }}
                                        >
                                          <span style={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap'
                                          }}>
                                            {displayText}
                                          </span>
                                          <span>{isOpen ? '▲' : '▼'}</span>
                                        </div>
    
                                        {isOpen && (
                                          <div style={{
                                            position: 'absolute',
                                            top: '100%',
                                            left: 0,
                                            right: 0,
                                            marginTop: '5px',
                                            border: '1px solid #ccc',
                                            borderRadius: '4px',
                                            backgroundColor: '#fff',
                                            boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                                            zIndex: 1000,
                                            maxHeight: '250px',
                                            overflowY: 'auto'
                                          }}>
    
                                            {/* 🔍 Search Input */}
                                            <input
                                              type="text"
                                              placeholder="Search staff..."
                                              value={searchText}
                                              onChange={(e) => setSearchText(e.target.value)}
                                              style={{
                                                width: '95%',
                                                margin: '10px auto',
                                                display: 'block',
                                                padding: '8px',
                                                borderRadius: '4px',
                                                border: '1px solid #ccc'
                                              }}
                                            />
    
                                            {/* Filtered Staff List */}
                                            {names.filter(staff =>
                                              staff.staffName.toLowerCase().includes(searchText.toLowerCase())
                                            ).length === 0 ? (
                                              <div style={{ padding: '10px', color: '#888', textAlign: 'center' }}>
                                                No Staffs found
                                              </div>
                                            ) : (
                                              names.filter(staff =>
                                                staff.staffName.toLowerCase().includes(searchText.toLowerCase())
                                              ).map((staff) => (
                                                <label
                                                  key={staff._id}
                                                  style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    padding: '10px',
                                                    cursor: 'pointer',
                                                    borderBottom: '1px solid #eee',
                                                  }}
                                                >
                                                  <input
                                                    type="checkbox"
                                                    checked={selectedNames.some(item => item._id === staff._id)}
                                                    onChange={() => handleCheckboxChange(staff)}
                                                    style={{ marginRight: '10px' }}
                                                    required
                                                  />
                                                  {staff.staffName}
                                                </label>
                                              ))
                                            )}
                                          </div>
                                        )}
                                      </div>
                                    </Col>
    
                                    <Col xs={12} md={6} className="text-start">
                                      <lable>Approve Person </lable>
                                      <br />
                                      <div ref={approveDropdownRef} style={{ position: 'relative', width: '85%', marginTop: '15px' }}>
                                        <div
                                          onClick={toggleApproveDropdown}
                                          style={{
                                            padding: '10px',
                                            border: '2px solid #a7a7a7',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            backgroundColor: '#fff',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginTop: '-5px'
    
                                          }}
                                        >
                                          <span style={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap'
                                          }}>
                                            {approvePersonText}
                                          </span>
                                          <span>{isApproveOpen ? '▲' : '▼'}</span>
                                        </div>
    
                                        {isApproveOpen && (
                                          <div style={{
                                            position: 'absolute',
                                            top: '100%',
                                            left: 0,
                                            right: 0,
                                            marginTop: '5px',
                                            border: '1px solid #ccc',
                                            borderRadius: '4px',
                                            backgroundColor: '#fff',
                                            boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                                            zIndex: 1000,
                                            maxHeight: '250px',
                                            overflowY: 'auto'
                                          }}>
                                            {/* 🔍 Search Input */}
                                            <input
                                              type="text"
                                              placeholder="Search staff..."
                                              value={searchTerm}
                                              onChange={(e) => setSearchTerm(e.target.value)}
                                              style={{
                                                width: '100%',
                                                padding: '8px 10px',
                                                borderBottom: '1px solid #ccc',
                                                boxSizing: 'border-box',
                                                outline: 'none',
                                                border: 'none'
                                              }}
                                            />
    
                                            {/* 🧑‍💼 Filtered Staff List */}
                                            {filteredNames.length === 0 ? (
                                              <div style={{ padding: '10px', color: '#888', textAlign: 'center' }}>
                                                No staff found
                                              </div>
                                            ) : (
                                              filteredNames.map((staff) => (
                                                <label
                                                  key={staff._id}
                                                  style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    padding: '10px',
                                                    cursor: 'pointer',
                                                    borderBottom: '1px solid #eee',
                                                  }}
                                                >
                                                  <input
                                                    type="checkbox"
                                                    required
                                                    checked={approvePersons.some((item) => item._id === staff._id)}
                                                    onChange={() => handleApproveCheckboxChange(staff)}
                                                    style={{ marginRight: '10px' }}
                                                  />
                                                  {staff.staffName}
                                                </label>
                                              ))
                                            )}
                                          </div>
                                        )}
    
                                      </div>
    
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
    
                              <Row>
                                <Col xs={12} md={6} className="text-start">
                                  <lable>Description</lable>
                                  <br />
                                  <textarea
                                    type="text"
                                    onChange={(e) =>
                                      handleInputChange(
                                        "description",
                                        e.target.value
                                      )
                                    }
                                    style={{
                                      textTransform: "capitalize",
                                      resize: "none",
                                    }}
                                    className="form-input inputfield-assign "
                                    placeholder="Enter Notes "
                                  />
                                </Col>
                                <Col>
                                  <Row>
                                    <Col xs={12} md={6} className="text-start">
                                      <lable>Lead ID</lable>
                                      <br />
                                      <input
                                        type="text"
                                        value={taskData.leadId}
                                        className="form-input overlay2"
                                        readOnly
                                      />
                                    </Col>
    
                                    <Col xs={12} md={6} className="text-start">
                                      <lable>Name </lable>
                                      <br />
                                      <input
                                        type="text"
                                        onChange={(e) =>
                                          handleInputChange("name", e.target.value)
                                        }
                                        style={{ textTransform: "capitalize" }}
                                        className="form-input "
                                        placeholder="Enter Notes "
                                        readOnly
                                        value={taskData.name}
                                      />
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col xs={12} md={6} className="text-start">
                                      <lable>Task Status </lable>
                                      <br />
                                      <input
                                        type="text"
                                        onChange={(e) =>
                                          handleInputChange(
                                            "taskStatus",
                                            e.target.value
                                          )
                                        }
                                        // style={{ textTransform: "capitalize" }}
                                         style={{
                            backgroundColor: "#fbdc6e",
                            color: "rgb(94, 94, 14)",
                            textTransform: "capitalize",
                          }}
                                        className="form-input "
                                        readonly
                                        value={taskData.taskStatus}
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </Container>
                          </div>
                        </div>
                      )}
  </>
)}

{/* Update Submit (Edit mode) */}
{isEditMode && isEditable && (
 <>
  <button
    className=" blue-btn"
    value="submit"
    type="submit"
  >
    Submit
  </button>

  <button
          className=" black-btn ms-2"
          type="button"
          onClick={() => {
            setAddComplaint(originalComplaint); // Restore from backup
            setIsEditable(false);
            setIsEditMode(false);
          }}
        >
          Cancel
        </button>
 </>


   
)}

</Col>


          </Row>

          <div className="border-container1">
            <h6 className="form-head  m-0 text-white  ">Complaint Details</h6>
          </div>

          <div className="border-container ">
            <Row className="text-start lead-id-row  mb-4 mt-4 ms-4 ">
            <p className="ps-5 paragraph-lead-id">
                Complaint ID - <span className="text-primary " value={addComplaint.leadId} onChange={handleChange}>
                  {addComplaint.leadId}</span>{" "}
                <span className="lead-start-date">
                  {" "}
                  Started Date & Time -{" "}
                  <span className="text-primary">{formatDate(addComplaint.createdDate)} - {currentTime}</span>
                </span>{" "}
              </p>
            </Row>
            <Row className="ms-3">
              <Col sm={12} md={6} className="text-start ">
                <lable>Customer Affected</lable>
                <br />
                {/* ── Searchable Customer Dropdown ── */}
                <div ref={customerDropRef} style={{ position: "relative", width: "85%" }}>
                  {/* Trigger box */}
                  <div
                    onClick={() => isEditable && setIsCustomerDropOpen((p) => !p)}
                    style={{
                      padding: "10px",
                      border: "2px solid #a7a7a7",
                      borderRadius: "4px",
                      cursor: isEditable ? "pointer" : "not-allowed",
                      backgroundColor: isEditable ? "#fff" : "#f5f5f5",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      minHeight: "42px",
                      marginTop: "6px",
                      textTransform: "capitalize",
                    }}
                  >
                    <span
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        color: selectedCustomer ? "#000" : "#aaa",
                        fontSize: "14px",
                      }}
                    >
                      {selectedCustomer
                        ? selectedCustomer.installcustomerName
                        : "Search & Select Customer"}
                    </span>
                    <span style={{ fontSize: "12px" }}>
                      {isCustomerDropOpen ? "▲" : "▼"}
                    </span>
                  </div>

                  {/* Dropdown panel */}
                  {isCustomerDropOpen && (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        marginTop: "4px",
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                        backgroundColor: "#fff",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        zIndex: 2000,
                        maxHeight: "260px",
                        overflowY: "auto",
                      }}
                    >
                      {/* Search input */}
                      <div style={{ padding: "8px", borderBottom: "1px solid #eee" }}>
                        <input
                          type="text"
                          autoFocus
                          placeholder="🔍 Search by name or ID..."
                          value={customerSearch}
                          onChange={(e) => setCustomerSearch(e.target.value)}
                          style={{
                            width: "100%",
                            padding: "7px 10px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            fontSize: "13px",
                            outline: "none",
                          }}
                        />
                      </div>

                      {/* Customer list */}
                      {completedCustomers
                        .filter((c) => {
                          const search = customerSearch.toLowerCase();
                          const leadNum = c.leadId ? c.leadId.split("-").pop().trim().toLowerCase() : "";
                          return (
                            (c.installcustomerName || "").toLowerCase().includes(search) ||
                            (c.customerid || "").toLowerCase().includes(search) ||
                            leadNum.includes(search) ||
                            String(c.installcontactNum || "").includes(search)
                          );
                        })
                        .map((customer) => (
                          <div
                            key={customer._id}
                            onClick={() => {
                              setSelectedCustomer(customer);
                              // Auto-fill complaint fields
                              setAddComplaint((prev) => ({
                                ...prev,
                                complaintcustomerAffected: customer.installcustomerName || "",
                                complaintcontactNum: String(customer.installcontactNum || ""),
                                complaintaddress: customer.installaddress || "",
                                location:
                                  customer.location?.latitude && customer.location?.longitude
                                    ? `${customer.location.latitude}, ${customer.location.longitude}`
                                    : prev.location,
                              }));
                              setCustomerSearch("");
                              setIsCustomerDropOpen(false);
                            }}
                            style={{
                              padding: "10px 14px",
                              cursor: "pointer",
                              borderBottom: "1px solid #f0f0f0",
                              transition: "background 0.15s",
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.backgroundColor = "#f0f7ff")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.backgroundColor = "transparent")
                            }
                          >
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: "13px",
                                textTransform: "capitalize",
                              }}
                            >
                              {customer.installcustomerName}
                            </div>
                            <div style={{ fontSize: "11px", color: "#666", marginTop: "2px" }}>
                              ID: {customer.leadId ? customer.leadId.split("-").pop().trim() : (customer.customerid || "N/A")} &nbsp;|&nbsp;
                              📞 {customer.installcontactNum}
                            </div>
                          </div>
                        ))}

                      {completedCustomers.filter((c) => {
                        const search = customerSearch.toLowerCase();
                        const leadNum = c.leadId ? c.leadId.split("-").pop().trim().toLowerCase() : "";
                        return (
                          (c.installcustomerName || "").toLowerCase().includes(search) ||
                          (c.customerid || "").toLowerCase().includes(search) ||
                          leadNum.includes(search) ||
                          String(c.installcontactNum || "").includes(search)
                        );
                      }).length === 0 && (
                        <div
                          style={{
                            padding: "12px",
                            textAlign: "center",
                            color: "#888",
                            fontSize: "13px",
                          }}
                        >
                          No completed customers found
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </Col>

              <Col sm={12} md={6} className="text-start ">
                <lable>Complaint Type</lable>
                <br />
                {/* <input
                   disabled={!isEditable}

                  type="text"
                  style={{ textTransform: "capitalize " }}
                  className="form-input complaint-type "
                  placeholder="Enter Complaint type"
                   value={addComplaint.complaintType} onChange={handleChange}
                  name="complaintType"
                  autoComplete="off"
                /> */}


                           <input
  type="text"
  name="complaintType"
  list="customerIssues"

                  style={{ textTransform: "capitalize " }}
                  className="form-input complaint-type "
                  autoComplete="off"
  
  disabled={!isEditable}
  value={addComplaint.complaintType}
  onChange={handleChange}
/>

<datalist id="customerIssues">
  <option value="Fiber Cut" />
  <option value="Loss Light" />
  <option value="Slow Speed" />
  <option value="Website Issues" />
  <option value="VPN Issues" />
</datalist>
              </Col>
              </Row>

              

            <Row className="ms-3">
              <Col xs={12} md={6} className="text-start">
                <lable> Address</lable>
                <br />
                <textarea
                 disabled={!isEditable}

                  type="text"
                  style={{ textTransform: "capitalize", resize: "none" }}
                  className=" box address-enquiry"
                  placeholder="Enter Installation Address"
                   value={addComplaint.complaintaddress} onChange={handleChange}
                  name="complaintaddress"
                />
              </Col>
              <Col>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Dependent</lable>
                    <br />
                    {/* <input
                      
                      style={{ textTransform: "capitalize"}}
                      className="form-input complaint-checkbox "
                      type="checkbox"
                      placeholder="Enter Account Manager"
                    /> Network Team */}

<label class="custom-checkbox">
  <input type="checkbox"
   value={addComplaint.complaintnetwork} onChange={handleChangecheckbox}
   disabled={!isEditable}

   name="complaintnetwork"/>
  <span className="checkbox-complaint-margin">Network Team</span> 
</label>

                  </Col>
                  <Col xs={12} md={6} className="text-start">
                  <Row className="checkbox-complaint-top">
                  <label class="custom-checkbox ">
  <input type="checkbox"
  value={addComplaint.complaintfiber} onChange={handleChangecheckbox}
  name="complaintfiber"
  disabled={!isEditable}

  />
  <span className="checkbox-complaint-margin">Fiber Team</span> 
</label>    
</Row>     
                  </Col>
                </Row>
                <Row>
                  <Row>
                                   <Col xs={12} md={6} className="text-start">
                                     <lable>
                                       Contact Number
                                       <sup>
                                         <FaStarOfLife size={7} />
                                       </sup>
                                     </lable>
                                     <br />
                                     <input
                                          disabled={!isEditable}
                                          type="tel"
                                       onKeyDown={(e) => {
                                         if (
                                           ["e", "E", "+", "-"].includes(e.key) ||
                                           (e.key &&
                                             !/[0-9]/.test(e.key) &&
                                             e.key !== "Backspace" &&
                                             e.key !== "ArrowLeft" &&
                                             e.key !== "ArrowRight")
                                         ) {
                                           e.preventDefault();
                                         }
                                       }}
                                      //  value={installContactNum}
                                       
                                       required
                                       placeholder="+91"
                                       className="form-input"
                                       value={addComplaint.complaintcontactNum} onChange={handleChange}
                                        name="complaintcontactNum"
                                     />
                                   </Col>
                 
                                   <Col xs={12} md={6} className="text-start">
                                     <lable>Location </lable>
                                     <br />
                                     <input
                                       type="text"
                                       
                                       className="form-input"
                                       placeholder="Enter Location"
                                       disabled={!isEditable}

                                       
                                       value={addComplaint.location} onChange={handleChange}
                                        name="location"
                                     />
                                   </Col>
                                 </Row>
                                 <Row>
                                 
                                                    <Col xs={12} md={6} className="text-start">
                                                      <lable>Additional Charge</lable>
                                                      <br />
                                                      <input
                                                           disabled={!isEditable}

                                                        className="field form-input"
                                                        value={addComplaint.complaintadditionalCharges} onChange={handleChange}
                                        name="complaintadditionalCharges"
                                                        
                                                        type="text"
                                                      />
                                                    </Col>
                                                    <Col xs={12} md={6} className="text-start">
                                                                        <lable>Lead Status</lable>
                                                                        <br />
                                                                        <input style={{backgroundColor:"#fbdc6e",color:"rgb(94, 94, 14)"}}
                                                                          type="button"
                                                                          onClick={() => setIsOpenComplaintOpen(true)}
                                                                          className="form-input converted-form"
                                                                          name="installleadStatus"
                                                                          value="Open"
                                                                          disabled={!isEditable}

                                                                        />
                                                                          
                                                                 
                                                    
                                                                        {isOpenComplaintOpen && (
                                                                          <div className="overlay1-converted">
                                                                            <div className="modal1-converted">
                                                                              <Container>
                                                                                <button
                                                                                  className="close-btn1"
                                                                                  onClick={() => setIsOpenComplaintOpen(false)}
                                                                                >
                                                                                  <span style={{ fontSize: "20px" }}>
                                                                                    {" "}
                                                                                    &times;{" "}
                                                                                  </span>
                                                                                </button>
                                                    
                                                                                <div className="open-button border">
                                                                                  <h5>Open</h5>
                                                                                </div>
                                                    
                                                                                <textarea
                                                                                  style={{
                                                                                    textTransform: "capitalize",
                                                                                    resize: "none",
                                                                                  }}
                                                                                  placeholder="Enter Notes"
                                                                                  className="converted-textbox"
                                                                                  name="complaintnotes"
                                                                                  onChange={handleLeadChange}
                                                    
                                                                                  value={addComplaint.complaintleadStatus.complaintnotes}
                                                                                />
                                                                                <div className="upload-section">
                                                                                  <label className="upload-btn">
                                                                                    <FiUpload className="upload-icon" />
                                                                                    Upload Image
                                                                                    <input
                                                                                      type="file"
                                                                                      accept="image/*"
                                                                                      onChange={handleFileChange}
                                                    
                                                    
                                                                                      hidden
                                                                                    />
                                                                                  </label>
                                                                                  {selectedFile && (
                                                                                    <p className="file-name">{selectedFile.name}</p>
                                                                                  )}
                                                                                </div>
                                                    
                                                                                <Row>
                                                                                  <Col className="date-update-textbox">
                                                                                    <label>Next Follow Up Date</label>
                                                                                    <br />
                                                                                    <input
                                                                                      type="date"
                                                                                      className="field form-input"
                                                                                      value={addComplaint.complaintleadStatus.complaintLeadStatusnextFollowUpDate} 
                                                                                      onChange={handleLeadChange}
                                                                                      name="complaintLeadStatusnextFollowUpDate"
                                                    
                                                                                    />
                                                                                  </Col>
                                                                                  <Col className="uploadbtn-install">
                                                                                    <button type="button" className="blue-btn"
                                                                                     onClick={() => setIsOpenComplaintOpen(false)}>
                                                                                      Upload
                                                                                    </button>
                                                                                  </Col>
                                                                                </Row>
                                                                              </Container>
                                                                            </div>
                                                                          </div>
                                                                        )}
                                                                      </Col>
                                                  </Row>
                                
                </Row>
              </Col>
            </Row>
           
          </div>
        </form>

           {showMessageBox && (
     < Row className="container ms-3  me-5" >
             <Col md={6} sm={12} >
               <div>{
                 messageData && messageData.map((msg) => (
                   <MessageBox key= { msg._id } message = { msg } />
                     ))
               } </div>
   
             </Col>
             < Col md={6} sm={12} className="" >
               {/* Updates History Section */}
               < div className="compact-updates-history" >
                 <div className="compact-updates-header" > Updates History </div>
                 {
                   messageData && messageData.map((data, index) => (
                     <div className="compact-update text-center" key={index} >
                       <div className="compact-update-date text-center" >
                         {
                           new Date(data.updatesHistory.date).toLocaleDateString("en-GB") +
                           " - " +
                           new Date(data.updatesHistory.date)
                             .toLocaleTimeString("en-US", {
                               hour: "2-digit",
                               minute: "2-digit",
                               hour12: true,
                             })
                             .replace(":", ".")
                         }
                       </div>
   
                       < div className="compact-update-user text-center" > {data.updatesHistory.staff?.name} </div>
                       < div
                         className={"compact-update-status text-center "}
                         style={{ color: data.colorCode ? data.colorCode : "#000000" }}
                       >
                         {data.updatesHistory.status}
                       </div>
                     </div>
                   ))}
               </div>
             </Col>
           </Row>
   
   )} 
        
      </Container>


    </>
  );
}
